import React from 'react';
import {NavLink} from "react-router-dom";
import Notice from "./components/notice";
import useNotices from "../../../hooks/public/useNotices";

const Notices = () => {
    const {data} = useNotices();

    return (
        <section className="notice-section">
            <div className="custom-container">
                <header className="notice-header">
                    <h1 className="notice-section-title">Notice</h1>
                    <NavLink to='/notices' className="all-notice-link">All notices</NavLink>
                </header>
                <div className="notice-body">
                    {data?.notices?.map((notice) => <Notice key={notice.id} notice={notice}/>)}
                </div>
            </div>
        </section>
    );
};

export default Notices;
